module.exports = __webpack_public_path__ + "media/images/cart_icon01-725e7e93951abe3aa7224f53725ba90d.svg";